/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import type { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Check',
  definitions: {
    '16': {
      viewBox: '0 0 17 17',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1632 3.16956C15.5766 3.53584 15.6147 4.16786 15.2484 4.5812L7.56843 13.2479C7.39147 13.4476 7.14205 13.5683 6.87565 13.5831C6.60924 13.5979 6.34795 13.5057 6.1499 13.3269L1.8299 9.42692C1.41996 9.05683 1.38765 8.42449 1.75774 8.01454C2.12783 7.6046 2.76017 7.57229 3.17011 7.94238L6.74096 11.1661L13.7516 3.25476C14.1179 2.84142 14.7499 2.80327 15.1632 3.16956Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
